var swiper = new Swiper(".mkeyCollectionSlider__bottom", {
  slidesPerView: 4,
  loop: true,
  navigation: {
    nextEl: ".arrNext",
    prevEl: ".arrPrew",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 0,
      slideToClickedSlide: true,
    },
    500: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1281: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});

const disbtn = document.querySelectorAll(".btn");
const disbtnn = document.querySelectorAll(".tt-cart-btn > div > a");
disbtnn.forEach((elem) => {
  elem.classList.remove("disabled");
   elem.disabled = false;
});
disbtn.forEach((elem) => {
  elem.classList.remove("disabled");
  elem.disabled = false;
});

if (
  document.querySelector(".pageproduct") ||
  document.readyState === "loading"
) {
  setTimeout(() => {
    let availFrontText = document.querySelector(
      ".pageproduct .product-information-buttons a:last-child"
    );
    let avail = document.querySelectorAll(".pageproduct .availability span");
    avail.forEach((elem) => {
      if (!elem.classList.contains("hide")) {
        if (elem.innerHTML == "Many in stock" || elem.innerHTML == "In Stock") {
          availFrontText.innerHTML = "In Stock, ready to ship!";
        } else {
          availFrontText.innerHTML = "NOT ready to ship!";
        }
      }
    });

      let sizes = document.querySelectorAll(".tt-options-swatch .options-color");
      sizes.forEach((elem) => {
        sizeTitle = elem.getAttribute("data-tooltip");
        elem.classList.add("newMkey");
        elem.textContent = sizeTitle;
      });

      const reloadBtns = document.querySelectorAll(".options-color");
      reloadBtns.forEach((elem) => {
        elem.addEventListener("click", () => {
          setTimeout(() => {
            window.location.reload();
          }, 10);
        });
      });
  }, 1000);
}

if (document.querySelector(".pagecart ") || document.readyState === "loading") {
  const reloadBtns = document.querySelectorAll(".plus-btn, .minus-btn");
  reloadBtns.forEach((elem) => {
    elem.addEventListener("click", () => {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  });

  initBanner();
  function initBanner() {
    const frontString = document.querySelector("#freeShip");
    let totalPriceString =
      document.querySelector("#grandtotal > td").textContent; //is a string like '100$'
    const freeShipBlock = document.querySelector(".free__ship");
    const notFreeShipBlock = document.querySelector(".not__free__ship");

    let totalPrice = parseFloat(totalPriceString.replace(/\$/g, "")); //convert the string to a number
    let needToBeFree = (69 - totalPrice).toFixed(2);
    let notFreeText = `You're just $${needToBeFree} away from free shipping!`;

    if (needToBeFree <= 0) {
      freeShipBlock.classList.remove("active");
      notFreeShipBlock.classList.add("active");
    } else {
      frontString.textContent = notFreeText;
      freeShipBlock.classList.add("active");
      notFreeShipBlock.classList.remove("active");
    }
  }
}

const interval = setInterval(() => {
  const stars = document.querySelectorAll(".tt-title svg path");
  if (stars.length > 0 ) {
    stars.forEach((elem) => {
      elem.classList.add("mkeyStar");
      elem.setAttribute(
        "d",
        "M8.00326 2.89347C8.35048 2.40579 8.66655 1.88254 9.04939 1.4355C11.0793 -0.931806 14.2889 -0.281558 15.4864 2.74615C16.4568 5.19982 15.9939 7.44012 14.5872 9.49754C13.6212 10.9098 12.2946 11.8394 11.0971 12.9469C10.0287 13.9375 8.98707 14.9738 7.91869 16C6.44521 14.0188 4.37522 12.637 2.58123 10.8793C1.38376 9.7109 0.462276 8.31897 0.123955 6.51555C-0.178753 4.87469 0.0705386 3.33544 0.898534 1.95366C2.29633 -0.36792 5.04296 -0.667643 6.82804 1.3085C7.2643 1.7911 7.61598 2.37023 7.99881 2.89347H8.00326Z"
      );
      elem.setAttribute("fill", "red");
    });
    clearInterval(interval);
  }
}, 500);

